<template>
  <div class="main">
    <div class="content">
      <img :src="agentInfo.logo" />
      <div class="flex">
        <span
          class="cp"
          @click="toOtherRouter(item.linkUrl)"
          v-for="item in menuList"
          :key="item.id"
        >
          {{ item.title }}</span
        >
        <span class="cp"><div class="learn-center">学习中心</div></span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: { ...mapGetters(["menuList"]) },
  data() {
    return {
      agentInfo: {},
    };
  },
  methods: {
    getGeneralSetting() {
      this.api.generalSetting.getGeneralSetting().then((res) => {
        this.agentInfo = res.data;
      });
    },
  },
  mounted() {
    this.getGeneralSetting();
  },
};
</script>
<style scoped>
.main {
  height: 60px;

  background: #fff;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
img {
  width: 180px;
  height: 40px;
}
.content {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
a {
  color: #000;
  margin-left: 16px;
}
span {
  color: #000;
  margin-left: 16px;
}
.learn-center {
  font-size: 14px;
  padding: 5px;
  width: 80px;
  text-align: center;
  background: #40a9ff;
  border-radius: 20px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/header/header1/index.vue